import React, { useEffect, useState } from 'react';
import { getGroupSetupContent, updateGroupSetupContent } from '../../services/groupSetupContentService';

const AdminGroupSetupContent = () => {
  const [draft, setDraft] = useState({ title: '', warningText: '', descriptionText: '', badgeText: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saveMsg, setSaveMsg] = useState('');

  const fetchContent = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getGroupSetupContent();
      setDraft({
        title: data.title || '',
        warningText: data.warningText || '',
        descriptionText: data.descriptionText || '',
        badgeText: data.badgeText || '',
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load content');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleSave = async () => {
    if (!draft.title.trim()) {
      setError('Title is required');
      return;
    }
    setSaving(true);
    setError('');
    setSaveMsg('');
    try {
      await updateGroupSetupContent(draft);
      setSaveMsg('Saved ✓');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p style={styles.status}>Loading content...</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>🍽️ "Create Your Shared Cookbook" Page</h2>
      <p style={styles.subtitle}>
        This is what a groupless user sees when they first land on their dashboard —
        typically brand-new users, or anyone whose group was deleted or who left one.
      </p>

      {error && <p style={styles.error}>{error}</p>}

      <label style={styles.fieldLabel}>Title</label>
      <input
        value={draft.title}
        onChange={(e) => setDraft({ ...draft, title: e.target.value })}
        style={styles.input}
      />

      <label style={styles.fieldLabel}>Warning callout <span style={styles.hint}>(the "already have an invite?" box)</span></label>
      <textarea
        value={draft.warningText}
        onChange={(e) => setDraft({ ...draft, warningText: e.target.value })}
        style={styles.textarea}
        rows={3}
      />

      <label style={styles.fieldLabel}>Description</label>
      <textarea
        value={draft.descriptionText}
        onChange={(e) => setDraft({ ...draft, descriptionText: e.target.value })}
        style={styles.textarea}
        rows={2}
      />

      <label style={styles.fieldLabel}>Badge text <span style={styles.hint}>(the "one-time purchase" pill)</span></label>
      <input
        value={draft.badgeText}
        onChange={(e) => setDraft({ ...draft, badgeText: e.target.value })}
        style={styles.input}
      />

      <div style={styles.actions}>
        {saveMsg && <span style={styles.saveMsg}>{saveMsg}</span>}
        <button onClick={handleSave} style={styles.saveBtn} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white', padding: '32px', borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', maxWidth: '600px',
  },
  title: { color: '#e67e22', marginBottom: '6px' },
  subtitle: { color: '#888', fontSize: '13px', marginBottom: '24px', lineHeight: 1.5 },
  fieldLabel: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#444', marginBottom: '6px', marginTop: '18px' },
  hint: { fontWeight: '400', color: '#aaa', fontSize: '12px' },
  input: {
    width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd',
    fontSize: '14px', boxSizing: 'border-box',
  },
  textarea: {
    width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd',
    fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box',
  },
  actions: { display: 'flex', alignItems: 'center', gap: '14px', marginTop: '24px' },
  saveBtn: {
    padding: '10px 24px', backgroundColor: '#e67e22', color: 'white', border: 'none',
    borderRadius: '8px', fontWeight: '600', cursor: 'pointer',
  },
  saveMsg: { color: '#27ae60', fontSize: '13px', fontWeight: '600' },
  status: { textAlign: 'center', color: '#999' },
  error: { color: '#e74c3c', marginBottom: '16px', fontSize: '13px' },
};

export default AdminGroupSetupContent;
